<ng-container *ngFor="let residence of residences; let residenceIndex = index">

  <ng-container *ngIf="!mortgageApplication.IsFactFind && residenceIndex === 0" class="form-element subtitle-section my-15">
    <p class="bo-info-text my-15" [innerHtml]="referenceDataLabels.WhatIsYourCurrentAddressId | localizeLabel"></p>
    <boi-form-information-box [decoration]="'exclamation-mark'"
      [message]="referenceDataLabels.ApplicantCurrentAddressSectionText">
    </boi-form-information-box>
  </ng-container>

  <ng-container *ngIf="residenceIndex > 0" class="form-element subtitle-section my-15">
    <p class="bo-info-text" [innerHtml]="referenceDataLabels.WhatIsYourPreviousAddressId | localizeLabel"></p>
  </ng-container>

  <boi-form-address [mortgageApplication]="mortgageApplication" [(address)]="residence.Address"
    [addressLine1Required]="true"
    [propertyName]="['Applicant_' + applicantIndex + '.ApplicantResidence_' + residenceIndex + '.Address']"
    [showCountryCode]="true" [hideFindAddress]="false"
    [areFieldsDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly">
  </boi-form-address>

  <!-- 53 & 54 -->
  <boi-form-term-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.HowLongHaveYouLivedHereId" [(years)]="residence.YearsAtAddress"
    [(months)]="residence.MonthsAtAddress" (yearsChange)="handleResidencesOverThreeYears()"
    (monthsChange)="handleResidencesOverThreeYears()"
    [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantResidence_' + residenceIndex + '.YearsAtAddress', 'Applicant_' + applicantIndex + '.ApplicantResidence_' + residenceIndex + '.MonthsAtAddress']">
  </boi-form-term-input>

  <!-- 55 -->
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [optionList]="referenceDataOptionLists.ResidentialStatus" [labelName]="referenceDataLabels.ResidentialStatus"
    [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantResidence_' + residenceIndex + '.ResidenceTypeCode']"
    [(value)]="residence.ResidenceTypeCode"></boi-form-option-list>

  <!-- 55.01 -->
  <ng-container *ngIf="residence.ResidenceTypeCode === referenceDataOptionLists.ResidentialStatusOther">
    <boi-form-textarea
      class="big-textarea"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.PleaseProvideDetails"
      [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantResidence_' + residenceIndex + '.ResidenceTypeDetails']"
      [(value)]="residence.ResidenceTypeDetails" [fieldMaxLength]="1500">
    </boi-form-textarea>
  </ng-container>

  <!-- 55.02 -->
  <ng-container *ngIf="isResidenceRented(residence) && residenceIndex === 0">
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [isCurrency]="true" [labelName]="referenceDataLabels.MonthlyRentalAmount"
      [(value)]="applicant.MonthlyRentalAmount"
      [propertyNames]="['Applicant_' + applicantIndex + '.MonthlyRentalAmount']" [fieldMaxLength]="8">
    </boi-form-numeric-input>
  </ng-container>
</ng-container>
